<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <g id="surface1">
      <path
        style="
          stroke: none;
          fill-rule: evenodd;
          fill: rgb(40.392157%, 44.705882%, 89.803922%);
          fill-opacity: 1;
        "
        d="M 69.164062 8.46875 L 68.863281 7.035156 L 64.664062 7.035156 L 64.664062 24.039062 L 69.515625 24.039062 L 69.515625 12.5 C 70.660156 11 72.597656 11.292969 73.210938 11.484375 L 73.210938 7.039062 C 72.566406 6.804688 70.300781 6.378906 69.164062 8.46875 Z M 59.433594 2.824219 L 54.699219 3.828125 L 54.679688 19.390625 C 54.679688 22.261719 56.835938 24.386719 59.714844 24.386719 C 61.300781 24.386719 62.472656 24.082031 63.121094 23.742188 L 63.121094 19.792969 C 62.5 20.039062 59.4375 20.929688 59.4375 18.070312 L 59.4375 11.171875 L 63.121094 11.171875 L 63.121094 7.035156 L 59.4375 7.035156 Z M 46.300781 11.96875 C 46.300781 11.210938 46.929688 10.921875 47.949219 10.921875 C 49.632812 10.957031 51.285156 11.382812 52.777344 12.171875 L 52.777344 7.601562 C 51.242188 6.996094 49.601562 6.695312 47.949219 6.710938 C 44.023438 6.710938 41.390625 8.769531 41.390625 12.199219 C 41.390625 17.570312 48.765625 16.699219 48.765625 19.011719 C 48.765625 19.917969 47.984375 20.199219 46.902344 20.199219 C 45.296875 20.199219 43.222656 19.535156 41.597656 18.648438 L 41.597656 23.277344 C 43.269531 24.007812 45.078125 24.386719 46.902344 24.394531 C 50.9375 24.394531 53.714844 22.402344 53.714844 18.910156 C 53.714844 13.113281 46.300781 14.152344 46.300781 11.96875 Z M 13.878906 9.515625 C 13.878906 8.144531 15.019531 7.613281 16.863281 7.613281 C 19.910156 7.679688 22.902344 8.453125 25.601562 9.875 L 25.601562 1.605469 C 22.816406 0.511719 19.851562 -0.03125 16.863281 0 C 9.761719 0 5 3.71875 5 9.929688 C 5 19.644531 18.34375 18.066406 18.34375 22.257812 C 18.34375 23.894531 16.941406 24.402344 14.972656 24.402344 C 12.066406 24.402344 8.316406 23.199219 5.371094 21.601562 L 5.371094 29.976562 C 8.402344 31.296875 11.667969 31.984375 14.972656 32 C 22.269531 32 27.300781 28.394531 27.300781 22.078125 C 27.300781 11.589844 13.878906 13.464844 13.878906 9.515625 Z M 13.878906 9.515625 "
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'StripeLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
